import { render, staticRenderFns } from "./DashboardSectionLinks.vue?vue&type=template&id=e95abb82"
import script from "./DashboardSectionLinks.vue?vue&type=script&lang=js"
export * from "./DashboardSectionLinks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports